import React from 'react'
import Card from '../Card'
import Text from '../Text'
import Tag from '../Tag'
import Icon from '../Icon'
import * as Icons from 'react-feather'
import Skeleton from '../Skeleton'
import { Identifiable } from '@/types'

type MenuCardItemProps = Identifiable<{
  label: string
  rightLabel: string
  sheetValue?: string
  chip?: React.ReactNode
  onClick?: () => void
  loading?: boolean
  className?: string
}>

export function MenuCardItem({
  id,
  label,
  rightLabel,
  sheetValue,
  chip,
  onClick,
  loading,
  className,
}: MenuCardItemProps) {
  return (
    <div
      id={id}
      key={id}
      onClick={onClick}
      className={`flex items-center justify-between w-full rounded cursor-pointer ${className} `}
    >
      <div>
        {loading ? (
          <Skeleton
            variant="rect"
            className="rounded-[12px]"
            width={99}
            height={20}
          />
        ) : (
          <Text variant="subheader">{label}</Text>
        )}
      </div>
      <div className="flex items-center">
        {loading ? (
          <Skeleton
            variant="rect"
            className="rounded-[12px]"
            width={99}
            height={20}
          />
        ) : (
          <>
            {sheetValue && (
              <Tag color="#E5FBEC" className="mr-4">
                <Text className="text-themed-green-900">{sheetValue}</Text>
              </Tag>
            )}
            {chip && <div className="mr-4">{chip}</div>}
            <Text
              id={`${id}-right-label`}
              className="pr-2 font-bold text-themed-grey-500"
            >
              {rightLabel}
            </Text>
            {onClick && (
              <Icon
                color="#5d5d5d"
                name="ChevronRight"
                className="w-5 h-5 text-themed-grey-500"
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

type MenuCardProps = {
  title: string | React.ReactNode
  icon?: keyof typeof Icons
  iconColor?: string
  children?: React.ReactNode
  className?: string
}

export default function MenuCard({
  title,
  children,
  icon,
  iconColor,
  className,
}: MenuCardProps) {
  return (
    <Card className={className}>
      <span className="flex items-center mb-5">
        {icon && (
          <Icon
            name={icon}
            color={iconColor ?? ''}
            className="mr-2"
            size={20}
          />
        )}
        <Text variant="h3">{title}</Text>
      </span>
      <div className="flex flex-col gap-2">{children}</div>
    </Card>
  )
}
